import { Button, Modal } from 'react-bootstrap';

interface AutoFaxModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

export default function AutoFaxModal({ show, onHide, onConfirm }: AutoFaxModalProps) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Enable Auto-Faxing</Modal.Title>
      </Modal.Header>
      <Modal.Body className='px-4 py-4'>
        <p className='mb-4'>
          When auto-faxing is enabled, results for all orders from this organization will be automatically faxed once
          they are available.
        </p>
        <p className='mb-3'>
          To begin faxing results, we first need to <strong>verify the fax number</strong> on file:
        </p>
        <ol className='mb-4 ps-4'>
          <li className='mb-2'>
            Once you <strong>save these changes</strong>, we'll send a fax containing a verification code.
          </li>
          <li className='mb-2'>
            <strong>Enter the verification code</strong> in the Fax Verification field within this Manage Organization
            section.
          </li>
          <li>
            <strong>Confirm the code</strong> to complete verification.
          </li>
        </ol>
        <div className='bg-light p-3 rounded'>
          <p className='mb-0 small text-muted'>
            <i className='fas fa-info-circle me-2'></i>
            The verification fax may take up to <strong>5 minutes</strong> to arrive. If you don't receive it within
            that time, you can request a new verification code from the same section of the provider portal.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={onConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
